import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import eventBus from '../utils/eventBus';
import { useTrackingContext } from './TrackingContext';

const EventBusBridge = (props) => {
  const [isSubscribed, setSubscribed] = useState(false);
  const { track } = useTrackingContext();

  useEffect(() => {
    const unsubscribe = eventBus.subscribe((action) => track(action));
    setSubscribed(true);

    return () => {
      unsubscribe();
    };
  }, [isSubscribed, track]);

  return <>{isSubscribed && props.children}</>;
};

EventBusBridge.propTypes = {
  children: PropTypes.node,
};

export default EventBusBridge;
